// 输入参数类型
export enum INPUT_PARAMETER_TYPE {
  text = "question",
  imageFirst = "image_first"
}
